import { Grid, IconButton, Typography } from '@mui/material';
import React, { useRef, useState } from 'react';
// import ReactToPrint from 'react-to-print';
import PieChartRelatorio from '../PieChartRelatorio';
import { usePallet } from "../../../../contexts/PalletContext";
import styled from 'styled-components';
import legis_agenda from "../../../../img/logo_legis_alta.png";
import PrintIcon from '@mui/icons-material/Print';
import { isMobile, isWindows } from 'react-device-detect';
import legis_agenda2 from "../../../../img/legis_agenda2.png";
import { fontSize } from '@mui/system';
import RelatorioService from "../../../../services/RelatoriosService";
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import { useQuery } from '../../../../utils/utils';
import CircularLoading from '../../../../components/CircularLoading';
import useStyles from "../../../../components/layout/Styles";
import Main from '../../../main/Main';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EmptyError from '../../../../components/EmptyError';

const Container = styled.div`
width: 100vw;
height: 100vh;
display: flex;
flex-direction: row;
justify-content: center;
align-items: center;
`;

const box = styled.div`
width: 300px;
height: 300px;
`;

export default function RelatorioInterlocutorQualificacaoPartido() {
    const classes = useStyles();
    const { pallet } = usePallet();
    const { dtIni } = useParams() as any;
    const { dtFin } = useParams() as any;
    const [loading, setLoading] = useState(false)

    let filter = useQuery().get('filter');
    const [filtro, setFiltro] = useState(filter)
    const [countConvergente, setCountConvergente] = useState()
    const [countDivergente, setCountDivergente] = useState()
    const [countNaoClassificado, setCountNaoClassificado] = useState()
    const [countNeutro, setCountNeutro] = useState()

    let totalGeralConvergente = 0;
    const[totalForaMapConvergente,setTotalForaMapConvergente] = useState(0);
    let totalGeralDivergente = 0;
    const[totalForaMapDivergente,setTotalForaMapDivergente] = useState(0);
    let totalGeralNaoClassificado = 0;
    const[totalForaMapNaoClassificado,setTotalForaMapNaoClassificado] = useState(0);
    let totalGeralNeutro = 0;
    const[totalForaMapNeutro,setTotalForaMapNeutro] = useState(0);

    const [dataConvergente, setDataConvergente] = useState([])
    const [dataDivergente, setDataDivergente] = useState([])
    const [dataNaoClassificado, setDataNaoClassificado] = useState([])
    const [dataNeutro, setDataNeutro] = useState([])

    //let esferaTipo = filter.substring(27, 29)
    let filtrotitle = []

    try { filtrotitle = JSON.parse(filter) } catch { filtrotitle = [] };

    let esferaTipo = (filtrotitle.length > 0 ? filtrotitle[0].value : "Geral")

    const Imprimir = () => {
        window.print()
    }

    React.useEffect(() => {
        setLoading(true)

        if (
            String(format(new Date(dtIni), "yyyy")).slice(0, 1) !== "0" &&
            String(format(new Date(dtFin), "yyyy")).slice(0, 1) !== "0"
        ) {

            RelatorioService.GetInterlocutorQualificacaoPartidoPeriodo(
                format(new Date(dtIni), "yyyy-MM-dd"),
                format(new Date(dtFin), "yyyy-MM-dd 23:59:00.000"),
                String(filtro)
            ).then(async res => {

                // setCountConvergente(res?.data?.totais?.convergente)
                // setCountDivergente(res?.data?.totais?.divergente)
                // setCountNaoClassificado(res?.data?.totais?.naoClassificado)
                // setCountNeutro(res?.data?.totais?.neutro)

                setDataConvergente(res?.data?.listas?.convergente)
                setDataDivergente(res?.data?.listas?.divergente)
                setDataNaoClassificado(res?.data?.listas?.naoClassificado)
                setDataNeutro(res?.data?.listas?.neutro)

                setLoading(false)
            })
        }
    }, []);

    React.useEffect(() => {

        dataConvergente?.map(x => {
                
            totalGeralConvergente +=  Number(x.count) 
            

            setTotalForaMapConvergente(totalGeralConvergente)

        })
    }, [dataConvergente]);


    React.useEffect(() => {

        dataDivergente?.map(x => {
                
            totalGeralDivergente +=  Number(x.count) 
            

            setTotalForaMapDivergente(totalGeralDivergente)

        })
    }, [dataDivergente]);

    React.useEffect(() => {

        dataNaoClassificado?.map(x => {
                
            totalGeralNaoClassificado +=  Number(x.count) 
            

            setTotalForaMapNaoClassificado(totalGeralNaoClassificado)

        })
    }, [dataNaoClassificado]);


    React.useEffect(() => {

        dataNeutro?.map(x => {
                
            totalGeralNeutro +=  Number(x.count) 
            

            setTotalForaMapNeutro(totalGeralNeutro)

        })
    }, [dataNeutro]);

    const CheckEsfera = (select) => {
        switch (select) {
            case 'F':
                return 'Federal'
            case 'E':
                return 'Estadual'
            case 'M':
                return 'Municipal'
            default:
                return 'Federal'
        }
    }

    return (
        // <div className={classes.root} >
        //     <Main>
        <div>
            <div className="relativeCSS">
                <style type="text/css" media="print">
                    {"\
                        @page { size: A4; }\
                    "}
                </style>
                <div className="flash" />
                <div style={{ width: '1000px', WebkitPrintColorAdjust: 'exact' }} >
                    <table className="testClass" style={{ width: '1000px' }} >
                        <thead>
                            <tr>
                                <td>
                                    <Grid container style={{
                                        padding: "20px",
                                        backgroundColor: `${pallet.general.color1}`,
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        height: '70px'
                                    }}>
                                        <Grid style={{}}>
                                            <img style={{ width: '100px' }} src={legis_agenda} />
                                        </Grid>
                                        <Grid style={{
                                            color: 'white',
                                            fontFamily: `${pallet.general.fontFamily}`,
                                            fontSize: `${pallet.general.size12}`
                                        }}>
                                            Monitoramento Inteligente no Poder Legislativo
                                        </Grid>
                                        <Grid>
                                            <IconButton onClick={Imprimir} style={{ color: 'white' }} aria-label="upload picture" component="span">
                                                <PrintIcon />
                                            </IconButton>
                                        </Grid>

                                    </Grid>
                                </td>
                            </tr>
                        </thead>
                        <tbody style={{
                            width: '900px',
                            // display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                            <tr>
                                <td>
                                    <Grid container style={{
                                        width: '990px',
                                        padding: '30px'
                                    }}>
                                        <Grid style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "left",
                                            // alignItems: "left",
                                        }}>
                                            <img style={{ width: '100px' }} src={legis_agenda2} />
                                        </Grid>
                                        <Grid style={{ marginLeft: '50px' }}>
                                            <Grid style={{
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontSize: `${pallet.general.size16}`,
                                            }}>
                                                Relatório / {esferaTipo}
                                            </Grid>
                                            <Grid style={{
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontSize: '20px',
                                                fontWeight: pallet.general.weight_bold,
                                                marginTop: '8px'
                                            }}>
                                                Interlocutores Distribuídos por Partido Político
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </td>
                            </tr>
                            <tr >
                                <td>
                                    {loading ?
                                        <CircularLoading
                                            size={100}
                                            top={isMobile ? "37%" : "40%"}
                                            left={isMobile ? "6%" : "16%"}
                                            zIndex={2}
                                        />
                                        :
                                        <Grid style={{
                                            width: '990px',
                                            marginTop: '30px',
                                            border: `1px solid #e0e0e0`,
                                            borderRadius: '7px'
                                        }}>
                                            <Grid container>
                                                <Grid item>
                                                    <Grid style={{
                                                        borderTopLeftRadius: '7px',
                                                        borderBottomLeftRadius: '7px',
                                                        backgroundColor: `${pallet.backgroundColorQuintenary}`,
                                                        padding: '15px',
                                                        marginTop: '-1px',
                                                        width: '70px',
                                                    }}>
                                                        <CalendarTodayIcon style={{
                                                            marginTop: '3px',
                                                            marginLeft: '8px',
                                                            color: `${pallet.textColorSecondary}`
                                                        }} />
                                                    </Grid>
                                                </Grid>
                                                <Grid item>
                                                    <Grid >
                                                        <Typography
                                                            style={{
                                                                color: `${pallet.color.quinternary.font}`,
                                                                fontSize: `${pallet.general.size16}`,
                                                                fontFamily: `${pallet.fontFamily.general}`,
                                                                fontWeight: pallet.general.weight_bold,
                                                                paddingLeft: "20px",
                                                                paddingTop: '10px'
                                                            }}>
                                                            PERÍODO DE APRESENTAÇÃO
                                                        </Typography>

                                                    </Grid>
                                                    <Grid>
                                                        <Grid container>
                                                            <Grid >
                                                                <Typography
                                                                    style={{
                                                                        color: `${pallet.color.secundary.font}`,
                                                                        fontSize: `${pallet.general.size12}`,
                                                                        fontFamily: `${pallet.fontFamily.general}`,
                                                                        fontWeight: pallet.general.weight_bold,
                                                                        paddingLeft: "20px"
                                                                    }}>
                                                                    {String(format(new Date(dtIni), 'dd/MM/yyyy'))}
                                                                </Typography>

                                                            </Grid>
                                                            <Grid >
                                                                <Typography
                                                                    style={{
                                                                        color: `${pallet.color.secundary.font}`,
                                                                        fontSize: `${pallet.general.size12}`,
                                                                        fontFamily: `${pallet.fontFamily.general}`,
                                                                        fontWeight: pallet.general.weight_bold,
                                                                        paddingLeft: "5px"
                                                                    }}>
                                                                    à
                                                                </Typography>

                                                            </Grid>
                                                            <Grid >
                                                                <Typography
                                                                    style={{
                                                                        color: `${pallet.color.secundary.font}`,
                                                                        fontSize: `${pallet.general.size12}`,
                                                                        fontFamily: `${pallet.fontFamily.general}`,
                                                                        fontWeight: pallet.general.weight_bold,
                                                                        paddingLeft: "5px"
                                                                    }}>
                                                                    {String(format(new Date(dtFin), 'dd/MM/yyyy'))}
                                                                </Typography>

                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {
                        dataConvergente && dataDivergente && dataNaoClassificado && dataNeutro ?
                            <Grid>
                                <table>
                                    <tbody>
                                        <tr>
                                            <Grid style={{marginTop: '70px'}}>
                                            TOTAL: {totalForaMapConvergente}
                                            </Grid>
                                            <Grid style={{
                                                fontSize: `${pallet.general.size18}`,
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontWeight: pallet.general.weight_600,
                                                color: `${pallet.color.secundary.font}`
                                            }}>
                                                | CONVERGENTE
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                                <Grid style={{
                                    border: `1px solid #e0e0e0`,
                                    marginTop: '20px',
                                    borderRadius: '7px'
                                }}>
                                    <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                        <tbody>
                                            <tr>

                                                <Grid container
                                                    display='flex'
                                                    justifyContent={'flex-start'}
                                                    direction='row'
                                                    style={{
                                                        height: '50px',
                                                        backgroundColor: `${pallet.backgroundGeneralPage}`,
                                                        borderTopLeftRadius: '7px',
                                                        borderTopRightRadius: '7px'
                                                    }}
                                                >
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        SIGLA
                                                    </Grid>
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        NOME DO PARTIDO
                                                    </Grid>
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        QUANTIDADE
                                                    </Grid>
                                                </Grid>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {dataConvergente.map(x => {
                                        return (
                                            <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                                <tbody>
                                                    <tr>
                                                        <Grid container
                                                            display='flex'
                                                            justifyContent={'flex-start'}
                                                            direction='row'
                                                            style={{
                                                                height: 'auto',
                                                                borderTop: `1px solid #e0e0e0`
                                                            }}
                                                        >
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.siglapartido}
                                                            </Grid>
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.descricao_partido}
                                                            </Grid>
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.count}
                                                            </Grid>
                                                        </Grid>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )
                                    })}


                                </Grid>
                                <table>
                                    <tbody>
                                        <tr>
                                           <Grid style={{marginTop: '70px'}}>
                                            TOTAL: {totalForaMapDivergente}
                                            </Grid>
                                            <Grid style={{
                                                fontSize: `${pallet.general.size18}`,
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontWeight: pallet.general.weight_600,
                                                color: `${pallet.color.secundary.font}`
                                            }}>
                                                | DIVERGENTE
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                                <Grid style={{
                                    border: `1px solid #e0e0e0`,
                                    marginTop: '20px',
                                    borderRadius: '7px'
                                }}>
                                    <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                        <tbody>
                                            <tr>
                                                <Grid container
                                                    display='flex'
                                                    justifyContent={'flex-start'}
                                                    direction='row'
                                                    style={{
                                                        height: '50px',
                                                        backgroundColor: `${pallet.backgroundGeneralPage}`,
                                                        borderTopLeftRadius: '7px',
                                                        borderTopRightRadius: '7px'
                                                    }}
                                                >
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        SIGLA
                                                    </Grid>
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        NOME DO PARTIDO
                                                    </Grid>
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        QUANTIDADE
                                                    </Grid>
                                                </Grid>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {dataDivergente.map(x => {
                                        return (
                                            <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                                <tbody>
                                                    <tr>
                                                        <Grid container
                                                            display='flex'
                                                            justifyContent={'flex-start'}
                                                            direction='row'
                                                            style={{
                                                                height: 'auto',
                                                                borderTop: `1px solid #e0e0e0`
                                                            }}
                                                        >
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.siglapartido}
                                                            </Grid>
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.descricao_partido}
                                                            </Grid>
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.count}
                                                            </Grid>
                                                        </Grid>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )
                                    })}


                                </Grid>
                                <table>
                                    <tbody>
                                        <tr>
                                            <Grid style={{marginTop: '70px'}}>
                                                TOTAL: {totalForaMapNaoClassificado}
                                            </Grid>
                                            <Grid style={{
                                                fontSize: `${pallet.general.size18}`,
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontWeight: pallet.general.weight_600,
                                                color: `${pallet.color.secundary.font}`
                                            }}>
                                                | NÃO CLASSIFICADO
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                                <Grid style={{
                                    border: `1px solid #e0e0e0`,
                                    marginTop: '20px',
                                    borderRadius: '7px'
                                }}>
                                    <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                        <tbody>
                                            <tr>
                                                <Grid container
                                                    display='flex'
                                                    justifyContent={'flex-start'}
                                                    direction='row'
                                                    style={{
                                                        height: '50px',
                                                        backgroundColor: `${pallet.backgroundGeneralPage}`,
                                                        borderTopLeftRadius: '7px',
                                                        borderTopRightRadius: '7px'
                                                    }}
                                                >
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        SIGLA
                                                    </Grid>
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        NOME DO PARTIDO
                                                    </Grid>
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        QUANTIDADE
                                                    </Grid>
                                                </Grid>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {dataNaoClassificado.map(x => {
                                        return (
                                            <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                                <tbody>
                                                    <tr>
                                                        <Grid container
                                                            display='flex'
                                                            justifyContent={'flex-start'}
                                                            direction='row'
                                                            style={{
                                                                height: 'auto',
                                                                borderTop: `1px solid #e0e0e0`
                                                            }}
                                                        >
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.siglapartido}
                                                            </Grid>
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.descricao_partido}
                                                            </Grid>
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.count}
                                                            </Grid>
                                                        </Grid>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )
                                    })}


                                </Grid>
                                <table>
                                    <tbody>
                                        <tr>
                                           <Grid style={{marginTop: '70px'}}>
                                                TOTAL: {totalForaMapNeutro}
                                            </Grid>
                                            <Grid style={{
                                                fontSize: `${pallet.general.size18}`,
                                                fontFamily: `${pallet.general.fontFamily}`,
                                                fontWeight: pallet.general.weight_600,
                                                color: `${pallet.color.secundary.font}`
                                            }}>
                                                | NEUTRO
                                            </Grid>
                                        </tr>
                                    </tbody>
                                </table>
                                <Grid style={{
                                    border: `1px solid #e0e0e0`,
                                    marginTop: '20px',
                                    borderRadius: '7px'
                                }}>
                                    <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                        <tbody>
                                            <tr>
                                                <Grid container
                                                    display='flex'
                                                    justifyContent={'flex-start'}
                                                    direction='row'
                                                    style={{
                                                        height: '50px',
                                                        backgroundColor: `${pallet.backgroundGeneralPage}`,
                                                        borderTopLeftRadius: '7px',
                                                        borderTopRightRadius: '7px'
                                                    }}
                                                >
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        SIGLA
                                                    </Grid>
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        NOME DO PARTIDO
                                                    </Grid>
                                                    <Grid style={{
                                                        width: '33%',
                                                        paddingTop: '15px',
                                                        paddingLeft: '25px',
                                                        fontFamily: `${pallet.general.fontFamily}`,
                                                        fontSize: `${pallet.general.size14}`,
                                                        color: `${pallet.textColorSecondary}`,
                                                        fontWeight: pallet.general.weight_600
                                                    }}>
                                                        QUANTIDADE
                                                    </Grid>
                                                </Grid>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {dataNeutro.map(x => {
                                        return (
                                            <table className="testClass" style={{ width: '1000px', marginTop: '-1px' }} >
                                                <tbody>
                                                    <tr>
                                                        <Grid container
                                                            display='flex'
                                                            justifyContent={'flex-start'}
                                                            direction='row'
                                                            style={{
                                                                height: 'auto',
                                                                borderTop: `1px solid #e0e0e0`
                                                            }}
                                                        >
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.siglapartido}
                                                            </Grid>
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.descricao_partido}
                                                            </Grid>
                                                            <Grid style={{
                                                                width: '33%',
                                                                paddingTop: '15px',
                                                                paddingLeft: '25px',
                                                                fontFamily: `${pallet.general.fontFamily}`,
                                                                fontSize: `${pallet.general.size14}`,
                                                            }}>
                                                                {x.count}
                                                            </Grid>
                                                        </Grid>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )
                                    })}


                                </Grid>
                            </Grid>
                            :
                            !loading &&
                            <Grid
                                style={{
                                    color: `${pallet.textColorQuaternary}`,
                                    fontSize: `${pallet.fontSize.titleWidgets}`,
                                    fontFamily: `${pallet.fontFamily.general}`,
                                    fontWeight: 600,
                                    textAlign: "center",
                                    paddingBottom: "98px",
                                    marginTop: "20px",
                                }}
                            >
                                <EmptyError title="Ops!" description="Ainda não temos dados suficientes para gerar resultados." />
                            </Grid>

                    }

                </div>
            </div>
        </div>
        //     </Main>
        // </div>
    );
};
